import { createCsvContent } from "@/helpers/csv";
import type { StatisticsDailyPoint } from "../_types/statistics-api.types";
import {
  STATISTICS_EXPORT_METRICS,
  type StatisticsExportMetricKey,
} from "../_constants/statistics-export.const";

function metricValue(
  point: StatisticsDailyPoint,
  key: StatisticsExportMetricKey,
): number {
  return point[key];
}

/**
 * One CSV row per day in `daily`, columns: Date + selected metrics (same meaning as dashboard tiles).
 */
export function buildStatisticsDailyCsv(
  daily: StatisticsDailyPoint[],
  selectedKeys: StatisticsExportMetricKey[],
): string {
  const columns = STATISTICS_EXPORT_METRICS.filter((m) =>
    selectedKeys.includes(m.key),
  );
  const headers = ["Date", ...columns.map((c) => c.label)];
  const sorted = [...daily].sort((a, b) => a.date.localeCompare(b.date));
  const rows = sorted.map((point) => [
    point.date,
    ...columns.map((c) => metricValue(point, c.key)),
  ]);
  return createCsvContent(headers, rows);
}
